import React, { useState, useEffect } from "react";

export default function PillMultiSelect({
                                            label,
                                            options, // [{value, label}]
                                            value = [],
                                            onChange,
                                            available = [], // optional: restrict selectable values
                                            t = (x) => x
                                        }) {
    const [selected, setSelected] = useState(value);

    useEffect(() => {
        setSelected(value);
    }, [value]);

    const toggle = (val) => {
        const next = selected.includes(val)
            ? selected.filter(v => v !== val)
            : [...selected, val];
        setSelected(next);
        onChange?.(next);
    };

    const isAvailable = (val) =>
        !available?.length || available.includes(val);

    return (
        <div className="pill-filter">
            {label && <div className="pill-filter-title">{t(label)}</div>}
            <div className="pill-filter-row">
                {options.map(opt => {
                    const active = selected.includes(opt.value);
                    const disabled = !isAvailable(opt.value);
                    return (
                        <button
                            type="button"
                            key={opt.value}
                            className={`pill ${active ? "active" : ""} ${disabled ? "pill-disabled" : ""}`}
                            onClick={() => !disabled && toggle(opt.value)}
                        >
                            {t(opt.label)}
                        </button>
                    );
                })}
            </div>
        </div>
    );
}
